import React from "react";
import { SanityCallToActionBar } from "../../model/common";
import CallToActionButton from "../CallToActionButton/CallToActionButton";
import styles from "./CallToActionBar.module.scss";

interface CallToActionButtonProps {
  node: SanityCallToActionBar;
}

const CallToActionBar = ({ node: { buttons } }: CallToActionButtonProps) => {
  return (
    <div className={styles.root}>
      {buttons.map(cta => (
        <CallToActionButton key={cta._key} node={cta} />
      ))}
    </div>
  );
};

export default CallToActionBar;
